import {StoreExt} from '@utils/reactExt'
import {action} from 'mobx'

class MeStoreG extends StoreExt {
    @action
    signOut = async () => {
        try {
            await this.api.loginOut({})
            localStorage.removeItem('userInfo')
            location.href = '#/global/login'
        } catch (e) {
        }
    }
}

const meStoreG = new MeStoreG()
export {meStoreG, MeStoreG}
